import { useMutation } from '@tanstack/react-query';
import { authTokenCreate } from '@wellstone-solutions/api/v2';
import { AxiosError, AxiosResponse } from 'axios';

import type { Login } from '@wellstone-solutions/api/v2';

const useLogin = () => {
  return useMutation<
    AxiosResponse<Login>,
    AxiosError<{ [key: string]: string[] }>,
    Login
  >({
    mutationFn: (data) => authTokenCreate(data, { skipAuthRefresh: true }),
  });
};

export { useLogin };
